<template>
  <div v-for="category in categories" :key="category.category">
    <template v-if="category.entries.length">
      <h3>{{ formatCategory(category.category) }}</h3>
      <table class="leaderboardtable">
        <colgroup>
          <col class="rank-col">
          <col class="player-col">
          <col class="pts-col">
          <col v-for="col in columns" class="event-col hideonmobile" :key="col.key">
        </colgroup>
        <thead>
          <tr>
            <th></th>
            <th>Joueur</th>
            <th>PTS</th>
            <th v-for="col in columns" class="hideonmobile ptsdetails" :key="col.key">{{ col.label }}</th>
          </tr>
          <tr class="hideonmobile tournament-info">
            <th colspan="3"></th>
            <th v-for="col in columns" :key="col.key">
              <div class="city">{{ col.info.place || '' }}</div>
              <div class="tournament-date">{{ formatShortDate(col.info.date) }}</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(entry, index) in category.entries" :key="index">
            <td><strong>{{ entry.clt || '-' }}</strong></td>
            <td>{{ stripEntityCodes(entry.joueur) }}</td>
            <td><strong>{{ entry.pts || '0' }}</strong></td>
            <td v-for="col in columns" class="hideonmobile" :key="col.key">{{ entry[col.key] ?? '' }}</td>
          </tr>
        </tbody>
      </table>
    </template>
  </div>
</template>

<script setup lang="ts">
import { formatCategory } from '@/functions/utils';
import {
  formatShortDate, stripEntityCodes, type RankingCategory, type RankingColumn,
} from '@/functions/leaderboards';

// Version anonyme d'un classement général : joueur sans code club/comité, points par
// tournoi, sans filtres. Partagée par LeaderboardScope (visiteur non connecté) et
// LeaderboardEmbed (iframe sur un site tiers).
defineProps<{ categories: RankingCategory[]; columns: RankingColumn[] }>();
</script>
